import React from 'react';

const SilentRenewCallback: React.FC = () => null;

export default SilentRenewCallback;
